import * as React from 'react';

import {Anchor, Text} from '@albert-io/atomic';

import sessionStore from 'client/Session/SessionStore';
import {history} from 'client/history';
import logger from 'lib/logger';
import {ERROR_TYPES} from 'client/constants';

import {redirectToLoginPageFromLocation, showGlobalLoginModal} from 'client/LogIn/utils';

class PromptLogIn extends React.Component {
  componentDidMount() {
    if (!sessionStore.hasValidSession()) {
      showGlobalLoginModal();
    }
  }

  showLogInModal = () => {
    showGlobalLoginModal();
  };

  render() {
    const button = <Anchor onClick={this.showLogInModal}>log in</Anchor>;

    return (
      <div className='text-center'>
        <Text>Please {button} to continue.</Text>
      </div>
    );
  }
}

export function requireSessionWithLoginPrompt(options = {}) {
  return requireSession({
    NoSessionComponent: PromptLogIn,
    ...options
  });
}

/**
 * @param rolePredicate {function}
 * @param NoSessionComponent {null|React.Component}
 * @param UnauthorizedSessionComponent {null|React.Component}
 * @returns {React.Component}
 */
export function requireSession({
  rolePredicate = () => {
    return true;
  },
  NoSessionComponent,
  UnauthorizedSessionComponent
} = {}) {
  return (DecoratedComponent) => {
    function RequireSessionGuard(props) {
      const hasValidSession = sessionStore.hasValidSession();
      const isAuthorized = hasValidSession && rolePredicate();

      // Navigate from an effect, never during render: router transitions are async, so a
      // render-phase redirect re-fires on every mid-transition re-render until React bails
      // with error #185 (HB 133593812; same defect class #19900 fixed in SubjectPracticeView).
      React.useEffect(() => {
        if (!hasValidSession) {
          if (!NoSessionComponent) {
            redirectToLoginPageFromLocation();
          }
          return;
        }
        if (!isAuthorized && !UnauthorizedSessionComponent) {
          history.replaceState(null, `/error?errorCode=${ERROR_TYPES.UNAUTHORIZED}`);
        }
      }, [hasValidSession, isAuthorized]);

      if (!hasValidSession) {
        logger.debug('No token found; rendering NoSessionComponent');
        return NoSessionComponent ? <NoSessionComponent /> : null;
      }

      if (isAuthorized) {
        logger.silly('rolePredicate is true, rendering decorated component');
        return <DecoratedComponent {...props} />;
      }

      logger.debug('rolePredicate is false, rendering Unauthorized component');
      return UnauthorizedSessionComponent ? <UnauthorizedSessionComponent /> : null;
    }

    return RequireSessionGuard;
  };
}
